module.exports = __webpack_public_path__ + "img/wic.b5379d6c.png";